interface AddHttpsProtocolToUrl {
  allowInternalUrl?: boolean;
}

export const addHttpsProtocolToUrl = (url: string, props: AddHttpsProtocolToUrl = {}) => {
  const { allowInternalUrl = false } = props;
  if (isValidUrl(url, { allowInternalUrl })) {
    const httpPattern = /^(?:(?:(?:https?|ftp):\/\/)|\/)/;
    url = !httpPattern.test(url) ? `https://${url}` : url;
    return url;
  }
  return url;
};

interface IsValidUrlProps {
  allowInternalUrl?: boolean;
}

export const isValidUrl = (url: string, props: IsValidUrlProps = {}) => {
  const { allowInternalUrl = false } = props;

  const urlPattern =
    /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/;
  const internalUrlPattern = /^\/[a-zA-Z0-9/_-]*$/;

  return urlPattern.test(url) || (allowInternalUrl && internalUrlPattern.test(url));
};

// TODO: Rename to isValidPathSegment
export const isValidInternalUrl = (url: string) => {
  const urlPattern = /^[a-zA-Z0-9-]+$/;
  return url.trim() !== '' && urlPattern.test(url);
};

export function validateExternalUrl(pageUrl: string) {
  if (!pageUrl.startsWith('http') && pageUrl.includes('.')) {
    return true;
  }
  return false;
}
